import * as React from 'react';
import * as _ from 'lodash';
import CheckBox from './../PageLayout/CheckBox';
import Pager2 from './../PageLayout/Pager2';
import classNames from 'classnames';
import { getFilterImage } from './../../utilities/helpers';
import { bkgImage } from './../../utilities/helpers';
import * as F from './../../constants/filters';
import { PARTS } from './../../schemas/accessRightsModel';
export default function () {
    function onClick1(expandedGroup, AR, g, gIndex) {
        AR.e(PARTS.FILTERS_EDIT_GROUP) && this.expandFilterGroup(g.id);
    }
    function onClick2(expandedGroup, AR, g, gIndex) {
        AR.e(PARTS.FILTERS_EDIT_VALUES) && this.goToFilterGroupItems(g.id);
    }
    function onClick3(expandedGroup, AR, g, gIndex) {
        this.confirmDeleteGroup(g.id);
    }
    function onChecked4(expandedGroup, AR, g, gIndex, value) {
        this.toggleGroupEnabled(g.id, value);
    }
    function onClick5(expandedGroup, AR, g, gIndex, e) {
        this.selectGroupIcon(e);
    }
    function onClick6(expandedGroup, AR, g, gIndex, e) {
        this.selectGroupIcon(e);
    }
    function onChange7(expandedGroup, AR, g, gIndex, e) {
        this.handleUploadFieldChange(e);
    }
    function onChange8(expandedGroup, AR, g, gIndex, e) {
        this.props.updateExpandedFilterGroupProp('name', e.target.value);
    }
    function onClick9(expandedGroup, AR, g, gIndex) {
        this.showFilterGroupVisualTypeSelectionPopup();
    }
    function onChange10(expandedGroup, AR, g, gIndex, e) {
        this.props.updateExpandedFilterGroupProp('description', e.target.value);
    }
    function onClick11(expandedGroup, AR, g, gIndex) {
        this.props.cancelFilterGroupEdit(this.props.expandedFilterGroupID);
    }
    function onClick12(expandedGroup, AR, g, gIndex) {
        this.saveGroup();
    }
    function repeatG13(expandedGroup, AR, g, gIndex) {
        return React.createElement('li', {
            'className': 'filter-groups-list__item',
            'key': g.id
        }, React.createElement('div', { 'className': 'filter-groups-list__item-row' }, React.createElement('div', { 'className': 'filter-groups-item filter-groups-item--left-buttons' }, React.createElement('div', { 'className': 'filter-groups-open-icon' }, AR.v(PARTS.FILTERS_EDIT_GROUP) ? React.createElement('button', {
            'className': classNames('ui-icon-arrow', {
                'ui-icon-arrow--right': g.id !== this.props.expandedFilterGroupID,
                'ui-icon-arrow--down': g.id === this.props.expandedFilterGroupID
            }),
            'onClick': onClick1.bind(this, expandedGroup, AR, g, gIndex),
            'key': '1077'
        }) : null), AR.v(PARTS.FILTERS_EDIT_VALUES) ? React.createElement('button', {
            'className': 'ui-icon-edit',
            'onClick': onClick2.bind(this, expandedGroup, AR, g, gIndex),
            'key': '1444'
        }) : null), React.createElement('div', { 'className': 'filter-groups-item filter-groups-item--remove' }, !g.isNew ? React.createElement('button', {
            'className': 'ui-icon-remove',
            'onClick': onClick3.bind(this, expandedGroup, AR, g, gIndex),
            'key': '1729'
        }) : null), React.createElement('div', { 'className': 'filter-groups-item' }, g.name), React.createElement('div', { 'className': 'filter-groups-item' }, AR.v(PARTS.FILTERS_ASSIGN_ENABLE) ? React.createElement(CheckBox, {
            'checked': g.enabled,
            'text': g.enabled ? 'Enabled' : 'Disabled',
            'disabled': !AR.e(PARTS.FILTERS_ASSIGN_ENABLE),
            'onChecked': onChecked4.bind(this, expandedGroup, AR, g, gIndex),
            'key': '1966'
        }) : null), React.createElement('div', { 'className': 'filter-groups-item' }, 'Visual Type: ', F.filterGroupVisualTypeDescription(g.visualType))), expandedGroup && g.id === this.props.expandedFilterGroupID ? React.createElement('div', {
            'className': 'filter-groups-list__item-dropdown',
            'key': '2388'
        }, React.createElement('div', { 'className': 'filter-groups-dropdown' }, React.createElement('div', { 'className': 'filter-groups-dropdown__title' }, 'Filter Group Parameters'), React.createElement('div', { 'className': 'filter-groups-dropdown__content' }, React.createElement('div', { 'className': 'filter-groups-image' }, React.createElement('div', { 'className': 'filter-groups-image__block' }, React.createElement('div', { 'className': 'table-cell' }, g.icon && g.icon.length ? React.createElement('div', {
            'className': 'filter-groups-image__block-image',
            'ref': 'iconHolder',
            'style': { 'backgroundImage': bkgImage(getFilterImage(g.icon) + '?' + this.props.imagesSeed) },
            'key': '2868'
        }) : null, React.createElement('div', { 'className': 'filter-groups-image__block-actions' }, !g.icon ? React.createElement('button', {
            'className': 'ui-button3 ui-button3--green ui-button3--wide',
            'onClick': onClick5.bind(this, expandedGroup, AR, g, gIndex),
            'key': '3205'
        }, 'add icon') : null, g.icon && g.icon.length ? React.createElement('button', {
            'className': 'ui-button3 ui-button3--green ui-button3--wide',
            'onClick': onClick6.bind(this, expandedGroup, AR, g, gIndex),
            'key': '3394'
        }, 'change icon') : null, React.createElement('input', {
            'type': 'file',
            'id': 'fileLoader',
            'name': 'files',
            'title': 'Load File',
            'style': { display: 'none' },
            'ref': 'fileLoader',
            'onChange': onChange7.bind(this, expandedGroup, AR, g, gIndex)
        }))))), React.createElement('div', { 'className': 'filter-groups-settings' }, React.createElement('div', { 'className': 'filter-groups-settings__block' }, React.createElement('span', { 'className': 'filter-groups-title' }, 'filter name'), expandedGroup.name === 'Edge' || expandedGroup.name === 'Edge Profile' ? React.createElement('h2', {
            'className': 'filter-groups-settings__block-filter-title',
            'key': '4093'
        }, expandedGroup.name) : null, expandedGroup.name !== 'Edge' && expandedGroup.name !== 'Edge Profile' ? React.createElement('input', {
            'className': 'ui-input2 filter-groups-settings__block-filter-name',
            'type': 'text',
            'placeholder': 'Enter Filter name',
            'value': expandedGroup.name,
            'onChange': onChange8.bind(this, expandedGroup, AR, g, gIndex),
            'key': '4272'
        }) : null), React.createElement('div', {
            'className': 'filter-groups-settings__block',
            'onClick': onClick9.bind(this, expandedGroup, AR, g, gIndex)
        }, React.createElement('span', { 'className': 'filter-groups-title' }, 'visual type'), React.createElement('button', { 'className': 'ui-button ui-button--blue ui-button--noborder ui-button--title ui-button--wide' }, React.createElement('span', { 'className': 'ui-button-icon ui-button-icon--arrow' }), React.createElement('span', { 'className': 'ui-button-text' }, F.filterGroupVisualTypeDescription(expandedGroup.visualType))))), React.createElement('div', { 'className': 'filter-groups-description' }, React.createElement('div', { 'className': 'filter-groups-description__block' }, React.createElement('span', { 'className': 'filter-groups-title' }, 'description'), React.createElement('textarea', {
            'className': 'ui-input2 filter-groups-description__block-textarea',
            'placeholder': 'Enter Group description',
            'value': expandedGroup.description || '',
            'onChange': onChange10.bind(this, expandedGroup, AR, g, gIndex)
        })), React.createElement('div', { 'className': 'filter-groups-description__buttons' }, React.createElement('button', {
            'className': 'ui-button4 ui-button4--blue ui-button4--small',
            'onClick': onClick11.bind(this, expandedGroup, AR, g, gIndex)
        }, 'Cancel'), React.createElement('button', {
            'className': 'ui-button4 ui-button4--green ui-button4--small',
            'onClick': onClick12.bind(this, expandedGroup, AR, g, gIndex)
        }, 'Save')))))) : null);
    }
    function scopeExpandedGroupAR14() {
        var expandedGroup = this.props.expandedFilterGroup;
        var AR = this.props.AR;
        return React.createElement('div', { 'className': 'app-content-wrapper2 app-content-wrapper2-adj app-content-wrapper2--small' }, React.createElement('div', { 'className': 'app-content-main' }, React.createElement('div', { 'className': 'filter-groups-container' }, React.createElement.apply(this, [
            'ul',
            { 'className': 'filter-groups-list ui-list' },
            _.map(this.props.groups, repeatG13.bind(this, expandedGroup, AR))
        ]))), this.props.totalPages > 1 ? React.createElement(Pager2, {
            'totalPages': this.props.totalPages,
            'page': this.props.page,
            'pageClick': this.handlePaginate,
            'key': '6231'
        }) : null);
    }
    return scopeExpandedGroupAR14.apply(this, []);
}